/* istanbul ignore file */
export enum ModalActionTypesEnum {
    SHOW_MODAL = 'modal/show',
    HIDE_MODAL = 'modal/hide'
}
